export default __webpack_public_path__ + "static/media/Logo gobierno colombia.ddc7b9f5.jpeg";